import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from 'components/Icon';
import { PromptsContext } from 'context/promptsContext';
import { useUsersContext } from 'context/usersContext';
import TaskSchedualsComp from './TaskSchedualsComp';

const SearchContainer = ({ closeNav, LoadTaskonchat, assistantData, updateAssistant, toggleSidebar }) => {
    const { promptsData } = useContext(PromptsContext);
    const {
        users: contacts,
        SSO,
        setUserAsUnread,
    } = useUsersContext();

    const [searchQuery, setSearchQuery] = useState('');
    const [data, setData] = useState({ prompts: [], chats: [], assistants: [] });
    const [activeTab, setActiveTab] = useState('all');

    /* ------------  FILTER LOGIC  ---------------- */
    useEffect(() => {
        let prompts = [];
        let chats = [];
        let assistants = [];

        if (activeTab === 'all' || activeTab === 'task') {
            if (promptsData?.prompt?.length) {
                prompts = promptsData.prompt
                    .filter(p =>
                        p.set_as === 'personal' &&
                        p.userId?.some(u => u.id === SSO?.userUUID)
                    )
                    .filter(p =>
                        p.title?.toLowerCase().includes(searchQuery.toLowerCase())
                    );
            }
        }

        if (activeTab === 'all' || activeTab === 'chat') {
            chats = contacts.filter(c =>
                c.name?.toLowerCase().includes(searchQuery.toLowerCase())
            );
        }

        if (activeTab === 'all' || activeTab === 'assistant') {
            assistants = assistantData.filter(a =>
                a.assistant_name?.toLowerCase().includes(searchQuery.toLowerCase())
            );
        }

        setData({ prompts, chats, assistants });
        if (searchQuery) setActiveTab(activeTab); // keep current tab
    }, [
        searchQuery,
        promptsData, contacts,
        assistantData,
        SSO,
        activeTab // add activeTab as dependency
    ]);

    // Helper to highlight and bold search matches
    const highlightMatch = (text, query) => {
        if (!query) return text;
        const regex = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
        return text.split(regex).map((part, i) =>
            regex.test(part)
                ? <span key={i} style={{ background: '#ffe066', fontWeight: 'bold' }}>{part}</span>
                : part
        );
    };

    /* ------------  RENDER HELPERS  ---------------- */
    const trunc = (txt = '', n = 18) =>
        txt.split(' ').length > n ? txt.split(' ').slice(0, n).join(' ') + '…' : txt;

    /* ------------  UI  ---------------- */

    const truncateWords = (text, wordLimit) => {
        const words = text.split(' ');
        if (words.length > wordLimit) {
            return words.slice(0, wordLimit).join(' ') + '...';
        }
        return text;
    };

    console.log('data.chats', data.chats);
    console.log('contacts', contacts);
    console.log('SSO', SSO);

    return (
        <div className="newUI_outer_container">
            <div className="newUI_container">
                <h1 className="newUI_title">Search</h1>

                <div className="newUI_search_bar_section">
                    <div className="newUI_search_input_box">
                        <div className="newUI_search_icon">
                            <Icon id="v3_search" />
                        </div>
                        <input
                            className="newUI_search_input"
                            placeholder="Search anything…"
                            value={searchQuery}
                            onChange={e => setSearchQuery(e.target.value)}
                        />
                    </div>

                    <select
                        className="newUI_filter_select"
                        value={activeTab}
                        onChange={e => setActiveTab(e.target.value)}
                    >
                        <option value="all">All</option>
                        <option value="chat">Chats</option>
                        <option value="task">Tasks</option>
                        <option value="assistant">Agents</option>
                    </select>
                </div>

                {/* ---------- TASKS (PROMPTS) ---------- */}
                {(activeTab === 'all' || activeTab === 'task') &&
                    (data.prompts || []).map(p => (
                        <div key={p._id} className="newUI_result_card"
                            onClick={() => LoadTaskonchat(p.title, p.prompt_value)}>
                            <div style={{ backgroundColor: '#F2FFED', color: '#757575' }} className="newUI_badge newUI_task_badge">Task</div>
                            <div>
                                <h3>{highlightMatch(truncateWords(p.title || '', 20), searchQuery)}</h3>
                                <p>{highlightMatch(truncateWords(p.prompt_value || '', 20), searchQuery)}</p>
                            </div>
                            <TaskSchedualsComp taskData={p} />
                        </div>
                    ))}

                {/* ---------- CHATS ---------- */}
                {(activeTab === 'all' || activeTab === 'chat') &&
                    data.chats?.filter(chat=> chat.name!=='force restart' && chat.name!=='Force restart' && chat.name!=='Force Restart' && chat.name!=='').map(chat => {
                        const firstKey = Object.keys(chat.messages || {})[0];
                        const userMessages = firstKey ? chat.messages[firstKey] : [];
                        const lastMsg = userMessages?.[userMessages.length - 1];
                        const timeParts = lastMsg?.time?.split(':');
                        const period = lastMsg?.time?.split(' ')[1];

                        const formattedTime = timeParts && period ? `${timeParts[0]}:${timeParts[1]} ${period}` : null;

                        return (
                            <Link
                                key={chat._id}
                                to={`/chat/${chat.id}`}
                                onClick={() => setUserAsUnread(chat.id)}
                                className="newUI_result_card"
                            >
                                <div style={{ color: '#757575' }} className="newUI_badge newUI_chat_badge">Chat</div>
                                <div>
                                    <h3 style={{ color: 'black' }}>{highlightMatch(truncateWords(chat.name, 20), searchQuery)}</h3>
                                    <p>{highlightMatch(truncateWords(chat.lastMessage || chat.name, 20), searchQuery)}</p>
                                </div>

                                {formattedTime && (
                                    <span className="newUI_meta">
                                        Last message&nbsp;{formattedTime}
                                    </span>
                                )}
                            </Link>
                        );
                    })}



                {/* ---------- AGENTS ---------- */}
                {(activeTab === 'all' || activeTab === 'assistant') &&
                    (data.assistants || []).map(item => (
                        <div key={item._id} className="newUI_result_card"
                            onClick={() => updateAssistant(item)}
                        >
                            <div style={{ backgroundColor: '#B9ECFF', color: '#757575' }} className="newUI_badge newUI_assistant_badge">Agent</div>
                            <div>
                                <h3 >{highlightMatch(truncateWords(item.assistant_name || '', 20), searchQuery)}</h3>
                                <p>{highlightMatch(truncateWords(item.description || '', 20), searchQuery)}</p>
                            </div>
                            {/* <span className="newUI_meta">Active now</span> */}
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default SearchContainer;
